import './css/famouscategories.css';


import AnimeShapes1 from './images/products/1.jpg';
import AnimeShapes2 from './images/products/2.jpg';
import AnimeShapes3 from './images/products/3.jpg';


function FamousCategories(){
    return(
        <>
            
    <section className="famous-categories">
            <div className='container-fluid'>
            <div className="row">
                <div className="header">
                    <h1> أشهر الأقسام </h1> 
                </div>


                <div className="categories">

                        <div className='row'>
                            
                    <div className="col-lg-2 col-md-3 col-sm-4 col-xs-6">
                            <div className="category">
                                <a href="#">
                                <img src={AnimeShapes3} alt="animeproduct"/>
                                    <h1>مجسمات يابانية </h1>
                                </a>
                            </div>
                    </div>
                        


                    <div className="col-lg-2 col-md-3 col-sm-4 col-xs-6">
                            <div className="category">
                                <a href="#">
                                <img src={AnimeShapes1} alt="animeproduct"/>
                                    <h1>مجسمات يابانية </h1>
                                </a>
                            </div>
                        </div>


                        <div className="col-lg-2 col-md-3 col-sm-4 col-xs-6">

                            <div className="category">
                                <a href="#">
                                <img src={AnimeShapes2} alt="animeproduct"/>
                                    <h1>مجسمات يابانية </h1>
                                </a>
                            </div>

                        </div>
                        


                        <div className="col-lg-2 col-md-3 col-sm-4 col-xs-6">

                            <div className="category">
                                <a href="#">
                                <img src={AnimeShapes3} alt="animeproduct"/>
                                    <h1>مجسمات يابانية </h1>
                                </a>
                            </div>

                        </div>
                        

                        <div className="col-lg-2 col-md-3 col-sm-4 col-xs-6">

                            <div className="category">
                                <a href="#">
                                <img src={AnimeShapes1} alt="animeproduct"/>
                                    <h1>مجسمات يابانية </h1>
                                </a>
                            </div>

                        </div>


                        <div className="col-lg-2 col-md-3 col-sm-4 col-xs-6">


                            <div className="category">
                                <a href="#">
                                <img src={AnimeShapes1} alt="animeproduct"/>
                                    <h1> مجسمات يابانية </h1>
                                </a>
                            </div>

                        </div>

                        </div>
                    
                </div>
            </div>
            </div>
    </section>


        </>
    )
}

export default FamousCategories;